
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("7peIa", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");

/* eslint-disable @repo/internal/react/no-class-components */ 



var $1oCLl = parcelRequire("1oCLl");


var $4FxUL = parcelRequire("4FxUL");

var $dYBVS = parcelRequire("dYBVS");











var $hmuU8 = parcelRequire("hmuU8");














var $dh538 = parcelRequire("dh538");


var $fpGTa = parcelRequire("fpGTa");


var $8j9VY = parcelRequire("8j9VY");


var $ay6Zz = parcelRequire("ay6Zz");




// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $b668d2859ee2840c$var$AT_PREFIX_REGEX = /^@/;
const $b668d2859ee2840c$var$MentionWithProfileCard = (0, $4pOgL.isReactCompilerActivePlatform)() ? function MentionWithProfileCard(t0) {
    const $ = (0, $frIzR.c)(51);
    const { autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId, ssrPlaceholderId: ssrPlaceholderId } = t0;
    const { cloudId: cloudId, renderUserMentionCard: renderUserMentionCard, resourceClient: resourceClient } = profilecardProvider;
    let t1;
    if ($[0] !== accessLevel || $[1] !== id || $[2] !== profilecardProvider || $[3] !== text) {
        t1 = profilecardProvider.getActions(id, text, accessLevel);
        $[0] = accessLevel;
        $[1] = id;
        $[2] = profilecardProvider;
        $[3] = text;
        $[4] = t1;
    } else t1 = $[4];
    const actions = t1;
    if ((0, $dh538.fg)("people-teams_migrate-user-profile-card")) {
        let t2;
        if ($[5] !== accessLevel || $[6] !== id || $[7] !== localId || $[8] !== mentionProvider || $[9] !== onClick || $[10] !== onMouseEnter || $[11] !== onMouseLeave || $[12] !== ssrPlaceholderId || $[13] !== text) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hmuU8.default), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                mentionProvider: mentionProvider,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                ssrPlaceholderId: ssrPlaceholderId
            });
            $[5] = accessLevel;
            $[6] = id;
            $[7] = localId;
            $[8] = mentionProvider;
            $[9] = onClick;
            $[10] = onMouseEnter;
            $[11] = onMouseLeave;
            $[12] = ssrPlaceholderId;
            $[13] = text;
            $[14] = t2;
        } else t2 = $[14];
        const mention = t2;
        if (renderUserMentionCard) {
            let t3;
            if ($[15] !== cloudId || $[16] !== id || $[17] !== mention || $[18] !== renderUserMentionCard) {
                t3 = renderUserMentionCard({
                    userId: id,
                    cloudId: cloudId,
                    children: mention
                });
                $[15] = cloudId;
                $[16] = id;
                $[17] = mention;
                $[18] = renderUserMentionCard;
                $[19] = t3;
            } else t3 = $[19];
            let t4;
            if ($[20] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, t3);
                $[20] = t3;
                $[21] = t4;
            } else t4 = $[21];
            return t4;
        }
        let t3;
        if ($[22] !== cloudId || $[23] !== id) {
            t3 = (0, $ay6Zz.navigateToTeamsApp)({
                type: "USER",
                payload: {
                    userId: id
                },
                cloudId: cloudId
            });
            $[22] = cloudId;
            $[23] = id;
            $[24] = t3;
        } else t3 = $[24];
        const { href: href, target: target } = t3;
        let t4;
        if ($[25] !== href || $[26] !== mention || $[27] !== target) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
                href: href,
                target: target,
                rel: "noopener noreferrer",
                testId: "mention-with-profilecard-link-fallback"
            }, mention);
            $[25] = href;
            $[26] = mention;
            $[27] = target;
            $[28] = t4;
        } else t4 = $[28];
        return t4;
    }
    let t2;
    if ($[29] !== text) {
        t2 = text.replace($b668d2859ee2840c$var$AT_PREFIX_REGEX, "");
        $[29] = text;
        $[30] = t2;
    } else t2 = $[30];
    let t3;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $1oCLl.expValEquals)("editor_a11y_7152_profile_card_tab_order", "isEnabled", true);
        $[31] = t3;
    } else t3 = $[31];
    let t4;
    if ($[32] !== accessLevel || $[33] !== id || $[34] !== localId || $[35] !== mentionProvider || $[36] !== onClick || $[37] !== onMouseEnter || $[38] !== onMouseLeave || $[39] !== ssrPlaceholderId || $[40] !== text) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hmuU8.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ssrPlaceholderId: ssrPlaceholderId
        });
        $[32] = accessLevel;
        $[33] = id;
        $[34] = localId;
        $[35] = mentionProvider;
        $[36] = onClick;
        $[37] = onMouseEnter;
        $[38] = onMouseLeave;
        $[39] = ssrPlaceholderId;
        $[40] = text;
        $[41] = t4;
    } else t4 = $[41];
    let t5;
    if ($[42] !== actions || $[43] !== autoFocus || $[44] !== cloudId || $[45] !== id || $[46] !== resourceClient || $[47] !== ssrPlaceholderId || $[48] !== t2 || $[49] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
            autoFocus: autoFocus,
            cloudId: cloudId,
            userId: id,
            resourceClient: resourceClient,
            actions: actions,
            trigger: "click",
            position: "bottom-end",
            testId: "mention-with-profilecard-trigger",
            ariaLabel: t2,
            ssrPlaceholderId: ssrPlaceholderId,
            isRenderedInPortal: t3
        }, t4);
        $[42] = actions;
        $[43] = autoFocus;
        $[44] = cloudId;
        $[45] = id;
        $[46] = resourceClient;
        $[47] = ssrPlaceholderId;
        $[48] = t2;
        $[49] = t4;
        $[50] = t5;
    } else t5 = $[50];
    return t5;
} : function MentionWithProfileCard({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId, ssrPlaceholderId: ssrPlaceholderId }) {
    const { cloudId: cloudId, renderUserMentionCard: renderUserMentionCard, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $42omo.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    if ((0, $dh538.fg)('people-teams_migrate-user-profile-card')) {
        const mention = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hmuU8.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ssrPlaceholderId: ssrPlaceholderId
        });
        if (renderUserMentionCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, renderUserMentionCard({
            userId: id,
            cloudId: cloudId,
            children: mention
        }));
        const { href: href, target: target } = (0, $ay6Zz.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: id
            },
            cloudId: cloudId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fpGTa.default), {
            href: href,
            target: target,
            rel: "noopener noreferrer",
            testId: "mention-with-profilecard-link-fallback"
        }, mention);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $8j9VY.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        ariaLabel: text.replace($b668d2859ee2840c$var$AT_PREFIX_REGEX, ''),
        ssrPlaceholderId: ssrPlaceholderId,
        isRenderedInPortal: (0, $1oCLl.expValEquals)('editor_a11y_7152_profile_card_tab_order', 'isEnabled', true)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $hmuU8.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    }));
};
var $b668d2859ee2840c$export$2e2bcd8739ae039 = $b668d2859ee2840c$var$MentionWithProfileCard;


const $ff1b0a16586f90d7$var$GENERIC_USER_IDS = [
    'HipChat',
    'all',
    'here'
];
const $ff1b0a16586f90d7$export$cd21803c89efe790 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo((0, $4pOgL.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $frIzR.c)(17);
    const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId } = t0;
    const [profilecardProvider, setProfilecardProvider] = (0, $42omo.useState)(null);
    const mountedRef = (0, $42omo.useRef)(true);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            mountedRef.current = true;
            return ()=>{
                mountedRef.current = false;
            };
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useLayoutEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] !== profilecardProviderResolver) {
        t3 = ()=>{
            profilecardProviderResolver?.then((result)=>{
                if (mountedRef.current) setProfilecardProvider(result);
            }).catch(()=>{
                if (mountedRef.current) setProfilecardProvider(null);
            });
        };
        t4 = [
            profilecardProviderResolver
        ];
        $[2] = profilecardProviderResolver;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $42omo.useLayoutEffect)(t3, t4);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $ff1b0a16586f90d7$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $b668d2859ee2840c$export$2e2bcd8739ae039) : (0, $hmuU8.default);
    const ssrPlaceholderId = `mention-${id}`;
    const t5 = eventHandlers?.onClick;
    const t6 = eventHandlers?.onMouseEnter;
    const t7 = eventHandlers?.onMouseLeave;
    let t8;
    if ($[5] !== MentionComponent || $[6] !== accessLevel || $[7] !== id || $[8] !== localId || $[9] !== mentionProvider || $[10] !== profilecardProvider || $[11] !== ssrPlaceholderId || $[12] !== t5 || $[13] !== t6 || $[14] !== t7 || $[15] !== text) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MentionComponent, {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            profilecardProvider: profilecardProvider,
            onClick: t5,
            onMouseEnter: t6,
            onMouseLeave: t7,
            ssrPlaceholderId: ssrPlaceholderId
        });
        $[5] = MentionComponent;
        $[6] = accessLevel;
        $[7] = id;
        $[8] = localId;
        $[9] = mentionProvider;
        $[10] = profilecardProvider;
        $[11] = ssrPlaceholderId;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
        $[15] = text;
        $[16] = t8;
    } else t8 = $[16];
    return t8;
} : ({ accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId })=>{
    const [profilecardProvider, setProfilecardProvider] = (0, $42omo.useState)(null);
    const mountedRef = (0, $42omo.useRef)(true);
    (0, $42omo.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $42omo.useLayoutEffect)(()=>{
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        profilecardProviderResolver?.then((result)=>{
            if (mountedRef.current) setProfilecardProvider(result);
        }).catch(()=>{
            if (mountedRef.current) setProfilecardProvider(null);
        });
    }, [
        profilecardProviderResolver
    ]);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $ff1b0a16586f90d7$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $b668d2859ee2840c$export$2e2bcd8739ae039) : (0, $hmuU8.default);
    const ssrPlaceholderId = `mention-${id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(MentionComponent, {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profilecardProvider: profilecardProvider,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    });
});


const $e6c99f3086a4122d$var$MENTION_PROVIDERS = [
    'mentionProvider',
    'profilecardProvider'
];
class $e6c99f3086a4122d$export$2e2bcd8739ae039 extends (0, $42omo.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        const providers = (0, $1oCLl.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $e6c99f3086a4122d$var$MENTION_PROVIDERS : [
            'mentionProvider',
            'profilecardProvider'
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dYBVS.WithProviders), {
            providers: providers,
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = (providers)=>{
            const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId } = this.props;
            const { mentionProvider: mentionProvider, profilecardProvider: profilecardProvider } = providers;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ff1b0a16586f90d7$export$cd21803c89efe790), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider
            });
        };
        this.providerFactory = props.providers || new (0, $4FxUL.default)();
    }
}






var $4wbMW = parcelRequire("4wbMW");

const $ab889215fc5612fa$var$_default_1 = /*#__PURE__*/ (0, $42omo.memo)((0, $4pOgL.isReactCompilerActivePlatform)() ? function MentionItem(props) {
    const $ = (0, $frIzR.c)(17);
    const { eventHandlers: eventHandlers, id: id, providers: providers, text: text, accessLevel: accessLevel, localId: localId } = props;
    const inlineAnnotationProps = (0, $4wbMW.useInlineAnnotationProps)(props);
    if ((0, $dh538.fg)("editor_inline_comments_on_inline_nodes")) {
        const t0 = eventHandlers && eventHandlers.mention;
        let t1;
        if ($[0] !== accessLevel || $[1] !== id || $[2] !== localId || $[3] !== providers || $[4] !== t0 || $[5] !== text) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6c99f3086a4122d$export$2e2bcd8739ae039), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                providers: providers,
                localId: localId,
                eventHandlers: t0
            });
            $[0] = accessLevel;
            $[1] = id;
            $[2] = localId;
            $[3] = providers;
            $[4] = t0;
            $[5] = text;
            $[6] = t1;
        } else t1 = $[6];
        let t2;
        if ($[7] !== inlineAnnotationProps || $[8] !== t1) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", inlineAnnotationProps, t1);
            $[7] = inlineAnnotationProps;
            $[8] = t1;
            $[9] = t2;
        } else t2 = $[9];
        return t2;
    }
    const t0 = eventHandlers && eventHandlers.mention;
    let t1;
    if ($[10] !== accessLevel || $[11] !== id || $[12] !== localId || $[13] !== providers || $[14] !== t0 || $[15] !== text) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6c99f3086a4122d$export$2e2bcd8739ae039), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            providers: providers,
            localId: localId,
            eventHandlers: t0
        });
        $[10] = accessLevel;
        $[11] = id;
        $[12] = localId;
        $[13] = providers;
        $[14] = t0;
        $[15] = text;
        $[16] = t1;
    } else t1 = $[16];
    return t1;
} : function MentionItem(props) {
    const { eventHandlers: eventHandlers, id: id, providers: providers, text: text, accessLevel: accessLevel, localId: localId } = props;
    const inlineAnnotationProps = (0, $4wbMW.useInlineAnnotationProps)(props);
    if ((0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("span", inlineAnnotationProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6c99f3086a4122d$export$2e2bcd8739ae039), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        eventHandlers: eventHandlers && eventHandlers.mention
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $e6c99f3086a4122d$export$2e2bcd8739ae039), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        eventHandlers: eventHandlers && eventHandlers.mention
    });
});
var $ab889215fc5612fa$export$2e2bcd8739ae039 = $ab889215fc5612fa$var$_default_1;
module.exports["default"] = $ab889215fc5612fa$export$2e2bcd8739ae039;

});

parcelRegister("hmuU8", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bqMS3 = parcelRequire("bqMS3");


var $6mYMS = parcelRequire("6mYMS");


var $9EfFC = parcelRequire("9EfFC");


var $jaPjp = parcelRequire("jaPjp");

class $c5f0794f64d5c686$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).PureComponent {
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $jaPjp.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $6mYMS.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $6mYMS.MentionNameStatus).SERVICE_ERROR:
            case (0, $6mYMS.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $9EfFC.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9EfFC.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            accessLevel: props.accessLevel,
            localId: props.localId,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            ssrPlaceholderId: props.ssrPlaceholderId
        });
    }
    constructor(_props){
        super(_props);
        this._isMounted = void 0;
        this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $bqMS3.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $6mYMS.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
}
module.exports["default"] = $c5f0794f64d5c686$export$2e2bcd8739ae039;

});

parcelRegister("4wbMW", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $dh538 = parcelRequire("dh538");


var $3h7Ko = parcelRequire("3h7Ko");

const $f39f21f184303967$export$11564cda945bb3c9 = (0, $4pOgL.isReactCompilerActivePlatform)() ? function useInlineAnnotationProps(props) {
    const $ = (0, $frIzR.c)(6);
    const { selectionDraftDocumentPosition: draftPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    if (!(0, $dh538.fg)("editor_inline_comments_on_inline_nodes")) {
        let t0;
        if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {};
            $[0] = t0;
        } else t0 = $[0];
        return t0;
    }
    if (!props.dataAttributes) {
        let t0;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t0 = {};
            $[1] = t0;
        } else t0 = $[1];
        return t0;
    }
    const inlineCardPosition = props.dataAttributes["data-renderer-start-pos"] - 1;
    const hasDraft = draftPosition && draftPosition?.from <= inlineCardPosition && draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) {
        let t0;
        if ($[2] !== inlineCardPosition) {
            t0 = {
                "data-renderer-mark": true,
                "data-annotation-draft-mark": true,
                "data-annotation-inline-node": true,
                "data-renderer-start-pos": inlineCardPosition
            };
            $[2] = inlineCardPosition;
            $[3] = t0;
        } else t0 = $[3];
        return t0;
    }
    let t0;
    if ($[4] !== inlineCardPosition) {
        t0 = {
            "data-annotation-inline-node": true,
            "data-annotation-mark": true,
            "data-renderer-start-pos": inlineCardPosition
        };
        $[4] = inlineCardPosition;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : function useInlineAnnotationProps(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $3h7Ko.useAnnotationRangeState)();
    if (!(0, $dh538.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
};
module.exports["useInlineAnnotationProps"] = $f39f21f184303967$export$11564cda945bb3c9;

});

parcelRegister("i0btU", function(module, exports) {

var $4pOgL = parcelRequire("4pOgL");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $bwC67 = parcelRequire("bwC67");

const $806263e9564ebacc$var$EMPTY = {};
const $806263e9564ebacc$var$useI18n = (0, $4pOgL.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $frIzR.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($806263e9564ebacc$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($806263e9564ebacc$var$EMPTY);
            (0, $bwC67.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($806263e9564ebacc$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useState($806263e9564ebacc$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useEffect(()=>{
        let aborted = false;
        setMessages($806263e9564ebacc$var$EMPTY);
        (0, $bwC67.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $806263e9564ebacc$var$MessagesIntlProvider = (0, $4pOgL.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $frIzR.c)(4);
    const { children: children } = props;
    const intl = (0, $aXWIB.useIntl)();
    const messages = $806263e9564ebacc$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
            ...intl,
            messages: messages
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $aXWIB.useIntl)();
    const messages = $806263e9564ebacc$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $806263e9564ebacc$export$2e2bcd8739ae039 = $806263e9564ebacc$var$MessagesIntlProvider;
function $806263e9564ebacc$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $806263e9564ebacc$export$2e2bcd8739ae039;

});

parcelRegister("bwC67", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $aXWIB = parcelRequire("aXWIB");


var $gjAAG = parcelRequire("gjAAG");

const $1cb8431546098045$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
const $1cb8431546098045$export$98e06fe7a6174253 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).unknownUserError);
const $1cb8431546098045$export$58bd5a2057b6b855 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessWarning);
const $1cb8431546098045$export$da9f8ce14593162f = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).noAccessLabel);
const $1cb8431546098045$export$4a258ffee7316766 = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultHeadline);
const $1cb8431546098045$export$702321a50d74536e = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).defaultAdvisedAction);
const $1cb8431546098045$export$ed7f16088a93ae9d = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).loginAgain);
const $1cb8431546098045$export$3ab158df56460d1c = $1cb8431546098045$export$392a0c6a82ab0e50((0, $gjAAG.messages).differentText);































const $1cb8431546098045$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("iWyg2")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("1YvbX")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("czJia")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("5twea")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("8wGCq")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("8ffMA")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("4ebsh")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("h0Nae")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("2rjCd")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("7wVzx")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("eYAzd")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("dJ6Pi")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("aMTu8")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("fB9vD")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("ctuC7")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("kAYXB")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("kszoB")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("diIb4")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("jOZnx")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("eD8co")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("dUGvg")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("e8vnv")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("dVKWy")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("4Jwts")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("dct7i")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("jEHCa")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("9677e")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("lksJj")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("1bipl")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("5FKXT")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $1cb8431546098045$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("5twea")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $1cb8431546098045$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $1cb8431546098045$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $1cb8431546098045$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $1cb8431546098045$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $1cb8431546098045$export$702321a50d74536e;
module.exports["LoginAgain"] = $1cb8431546098045$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $1cb8431546098045$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $1cb8431546098045$export$d0a3169680473b6c;

});

parcelRegister("gjAAG", function(module, exports) {

var $aXWIB = parcelRequire("aXWIB");

const $898c0db98da1400a$export$defe85febe8b728c = (0, $aXWIB.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});
module.exports["messages"] = $898c0db98da1400a$export$defe85febe8b728c;

});

parcelRegister("iWyg2", function(module, exports) {

let $dca837a70e1ba127$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $dca837a70e1ba127$var$load("4Mixi"),
    $dca837a70e1ba127$var$load("1jsQH"),
    $dca837a70e1ba127$var$load("bv8GZ"),
    $dca837a70e1ba127$var$load("i9sd0"),
    $dca837a70e1ba127$var$load("i5eMd"),
    $dca837a70e1ba127$var$load("4DYJ5"),
    $dca837a70e1ba127$var$load("gyXEE"),
    $dca837a70e1ba127$var$load("hoPZ9")
]).then(()=>parcelRequire('6Yuab'));

});

parcelRegister("1YvbX", function(module, exports) {

let $17039717377e3cdf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $17039717377e3cdf$var$load("cjveN"),
    $17039717377e3cdf$var$load("deyvi"),
    $17039717377e3cdf$var$load("cdeuH"),
    $17039717377e3cdf$var$load("aNg21"),
    $17039717377e3cdf$var$load("4UPfH"),
    $17039717377e3cdf$var$load("hfFxJ"),
    $17039717377e3cdf$var$load("1Mp9N"),
    $17039717377e3cdf$var$load("2Fu3d")
]).then(()=>parcelRequire('biDFC'));

});

parcelRegister("czJia", function(module, exports) {

let $927be2f6ddcd7086$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $927be2f6ddcd7086$var$load("8XGJb"),
    $927be2f6ddcd7086$var$load("6dERU"),
    $927be2f6ddcd7086$var$load("7gF8f"),
    $927be2f6ddcd7086$var$load("YEGhv"),
    $927be2f6ddcd7086$var$load("gd4qs"),
    $927be2f6ddcd7086$var$load("gofGr"),
    $927be2f6ddcd7086$var$load("dBb6q"),
    $927be2f6ddcd7086$var$load("eJgH8")
]).then(()=>parcelRequire('e7zr1'));

});

parcelRegister("5twea", function(module, exports) {

let $3fc8a8e755b35ba7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $3fc8a8e755b35ba7$var$load("2YffH").then(()=>parcelRequire('gbdrY'));

});

parcelRegister("8wGCq", function(module, exports) {

let $63525f118eb34896$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $63525f118eb34896$var$load("hdvZr"),
    $63525f118eb34896$var$load("kTurq"),
    $63525f118eb34896$var$load("djb49"),
    $63525f118eb34896$var$load("d8WL7"),
    $63525f118eb34896$var$load("fviv5"),
    $63525f118eb34896$var$load("2RQvP"),
    $63525f118eb34896$var$load("7Lkvk")
]).then(()=>parcelRequire('4ykQ2'));

});

parcelRegister("8ffMA", function(module, exports) {

let $600bf78d50760720$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $600bf78d50760720$var$load("4ViGN"),
    $600bf78d50760720$var$load("j0PWv"),
    $600bf78d50760720$var$load("ksTQ6"),
    $600bf78d50760720$var$load("j5F5K"),
    $600bf78d50760720$var$load("eBoC7"),
    $600bf78d50760720$var$load("7NpX8"),
    $600bf78d50760720$var$load("cukQS"),
    $600bf78d50760720$var$load("5FaEJ")
]).then(()=>parcelRequire('4FRcU'));

});

parcelRegister("4ebsh", function(module, exports) {

let $31415afcef6a6469$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $31415afcef6a6469$var$load("32vlK"),
    $31415afcef6a6469$var$load("dlmud"),
    $31415afcef6a6469$var$load("5CGnz"),
    $31415afcef6a6469$var$load("dXu4x"),
    $31415afcef6a6469$var$load("bNv64"),
    $31415afcef6a6469$var$load("bFU3Y"),
    $31415afcef6a6469$var$load("3CucM"),
    $31415afcef6a6469$var$load("9yemY")
]).then(()=>parcelRequire('bG4aH'));

});

parcelRegister("h0Nae", function(module, exports) {

let $c62892b55bb0439e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c62892b55bb0439e$var$load("7snhF"),
    $c62892b55bb0439e$var$load("X0Jic"),
    $c62892b55bb0439e$var$load("34YSq"),
    $c62892b55bb0439e$var$load("bAoKR"),
    $c62892b55bb0439e$var$load("5IaSN")
]).then(()=>parcelRequire('kVRsY'));

});

parcelRegister("2rjCd", function(module, exports) {

let $1c6d51973e42ac94$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $1c6d51973e42ac94$var$load("bjoGV"),
    $1c6d51973e42ac94$var$load("cbkj0"),
    $1c6d51973e42ac94$var$load("9Oxgj"),
    $1c6d51973e42ac94$var$load("18TX5"),
    $1c6d51973e42ac94$var$load("4Afgd"),
    $1c6d51973e42ac94$var$load("exaJ2"),
    $1c6d51973e42ac94$var$load("lp8Wm"),
    $1c6d51973e42ac94$var$load("l2LZP")
]).then(()=>parcelRequire('FrZOj'));

});

parcelRegister("7wVzx", function(module, exports) {

let $57b82e2efe873583$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $57b82e2efe873583$var$load("8oiz7"),
    $57b82e2efe873583$var$load("17m16"),
    $57b82e2efe873583$var$load("kAg8V"),
    $57b82e2efe873583$var$load("9Cdzw"),
    $57b82e2efe873583$var$load("cMubu"),
    $57b82e2efe873583$var$load("hcCcg"),
    $57b82e2efe873583$var$load("cHWSM"),
    $57b82e2efe873583$var$load("35Ssm")
]).then(()=>parcelRequire('225Fx'));

});

parcelRegister("eYAzd", function(module, exports) {

let $ae7308bb98355904$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae7308bb98355904$var$load("hFxmj"),
    $ae7308bb98355904$var$load("b4NO6"),
    $ae7308bb98355904$var$load("fM2oh"),
    $ae7308bb98355904$var$load("guNAg"),
    $ae7308bb98355904$var$load("3fLE9"),
    $ae7308bb98355904$var$load("j9KTb"),
    $ae7308bb98355904$var$load("b37xN"),
    $ae7308bb98355904$var$load("ik6u5")
]).then(()=>parcelRequire('alG1N'));

});

parcelRegister("dJ6Pi", function(module, exports) {

let $9fe4c5e3bbeeb3c3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $9fe4c5e3bbeeb3c3$var$load("fModo").then(()=>parcelRequire('lQyzT'));

});

parcelRegister("aMTu8", function(module, exports) {

let $7da96d436e1303bd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7da96d436e1303bd$var$load("BXOZB"),
    $7da96d436e1303bd$var$load("1K1Fj"),
    $7da96d436e1303bd$var$load("xnqy2"),
    $7da96d436e1303bd$var$load("cM3gY"),
    $7da96d436e1303bd$var$load("8hOn0"),
    $7da96d436e1303bd$var$load("3hjAq"),
    $7da96d436e1303bd$var$load("7PjNK"),
    $7da96d436e1303bd$var$load("Vt6S9")
]).then(()=>parcelRequire('gSUUF'));

});

parcelRegister("fB9vD", function(module, exports) {

let $b5b1b010e0d3f8ab$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b5b1b010e0d3f8ab$var$load("9Xiuh"),
    $b5b1b010e0d3f8ab$var$load("38sfA"),
    $b5b1b010e0d3f8ab$var$load("awkVi"),
    $b5b1b010e0d3f8ab$var$load("6yRq3"),
    $b5b1b010e0d3f8ab$var$load("h4OCL"),
    $b5b1b010e0d3f8ab$var$load("2bCHJ"),
    $b5b1b010e0d3f8ab$var$load("ktSfi"),
    $b5b1b010e0d3f8ab$var$load("9GZ76")
]).then(()=>parcelRequire('cF55v'));

});

parcelRegister("ctuC7", function(module, exports) {

let $914ff0bb8aa2c368$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $914ff0bb8aa2c368$var$load("7Odo3"),
    $914ff0bb8aa2c368$var$load("bjmre"),
    $914ff0bb8aa2c368$var$load("11DLa"),
    $914ff0bb8aa2c368$var$load("cft22"),
    $914ff0bb8aa2c368$var$load("bcQs2"),
    $914ff0bb8aa2c368$var$load("fdXnq"),
    $914ff0bb8aa2c368$var$load("iouLY"),
    $914ff0bb8aa2c368$var$load("4sOIV")
]).then(()=>parcelRequire('4IbNl'));

});

parcelRegister("kAYXB", function(module, exports) {

let $efe674e091118520$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $efe674e091118520$var$load("4VkvT"),
    $efe674e091118520$var$load("asvK9"),
    $efe674e091118520$var$load("barSq"),
    $efe674e091118520$var$load("gctEz"),
    $efe674e091118520$var$load("aBa7j"),
    $efe674e091118520$var$load("cItJR"),
    $efe674e091118520$var$load("hPZE5"),
    $efe674e091118520$var$load("QTjdE")
]).then(()=>parcelRequire('jKge3'));

});

parcelRegister("kszoB", function(module, exports) {

let $ee51e109396074e0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee51e109396074e0$var$load("g5qJV"),
    $ee51e109396074e0$var$load("7v6wU"),
    $ee51e109396074e0$var$load("a8heY"),
    $ee51e109396074e0$var$load("9PPH7"),
    $ee51e109396074e0$var$load("b544F"),
    $ee51e109396074e0$var$load("SctKm"),
    $ee51e109396074e0$var$load("dzIm8"),
    $ee51e109396074e0$var$load("hrf1M")
]).then(()=>parcelRequire('lGLcJ'));

});

parcelRegister("diIb4", function(module, exports) {

let $9aef399064f89ced$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $9aef399064f89ced$var$load("dPa6p"),
    $9aef399064f89ced$var$load("aEpRh"),
    $9aef399064f89ced$var$load("6hlNE"),
    $9aef399064f89ced$var$load("1y1eN"),
    $9aef399064f89ced$var$load("K6fhx"),
    $9aef399064f89ced$var$load("1fJz1"),
    $9aef399064f89ced$var$load("jqwnR"),
    $9aef399064f89ced$var$load("lsloj")
]).then(()=>parcelRequire('d7PIu'));

});

parcelRegister("jOZnx", function(module, exports) {

let $e6e24c5da898ba6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e6e24c5da898ba6d$var$load("iG4uh"),
    $e6e24c5da898ba6d$var$load("3fuR9"),
    $e6e24c5da898ba6d$var$load("2bqSD"),
    $e6e24c5da898ba6d$var$load("e8jpx"),
    $e6e24c5da898ba6d$var$load("gZU54"),
    $e6e24c5da898ba6d$var$load("9yA8o"),
    $e6e24c5da898ba6d$var$load("bGhLc"),
    $e6e24c5da898ba6d$var$load("iRKhU")
]).then(()=>parcelRequire('jwd3r'));

});

parcelRegister("eD8co", function(module, exports) {

let $aa6b115a311b9fd0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $aa6b115a311b9fd0$var$load("aGECO").then(()=>parcelRequire('c2Dmg'));

});

parcelRegister("dUGvg", function(module, exports) {

let $a21179997b16d6f7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a21179997b16d6f7$var$load("bSjyK"),
    $a21179997b16d6f7$var$load("j6IGj"),
    $a21179997b16d6f7$var$load("6tWAg"),
    $a21179997b16d6f7$var$load("hlJc4"),
    $a21179997b16d6f7$var$load("aOdaf")
]).then(()=>parcelRequire('l9Ug4'));

});

parcelRegister("e8vnv", function(module, exports) {

let $a4aa27148dad9d3a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a4aa27148dad9d3a$var$load("9tVE8"),
    $a4aa27148dad9d3a$var$load("fMrUo"),
    $a4aa27148dad9d3a$var$load("bJykp"),
    $a4aa27148dad9d3a$var$load("fjbzp"),
    $a4aa27148dad9d3a$var$load("4Wdqb"),
    $a4aa27148dad9d3a$var$load("448N7"),
    $a4aa27148dad9d3a$var$load("9v6ER"),
    $a4aa27148dad9d3a$var$load("aEAsN")
]).then(()=>parcelRequire('fkCIe'));

});

parcelRegister("dVKWy", function(module, exports) {

let $a245033a20d44784$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $a245033a20d44784$var$load("5WkxF").then(()=>parcelRequire('hW2zm'));

});

parcelRegister("4Jwts", function(module, exports) {

let $37248e16b030f0da$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $37248e16b030f0da$var$load("6UAlo"),
    $37248e16b030f0da$var$load("9eNkX"),
    $37248e16b030f0da$var$load("dh2Er"),
    $37248e16b030f0da$var$load("1pFHs"),
    $37248e16b030f0da$var$load("k10Cs"),
    $37248e16b030f0da$var$load("gBDdh"),
    $37248e16b030f0da$var$load("8Mz40"),
    $37248e16b030f0da$var$load("l6YHr")
]).then(()=>parcelRequire('gR0Ux'));

});

parcelRegister("dct7i", function(module, exports) {

let $99c2fb5138729985$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $99c2fb5138729985$var$load("l7PQP").then(()=>parcelRequire('bRxNE'));

});

parcelRegister("jEHCa", function(module, exports) {

let $e4f395b7fd009e5c$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e4f395b7fd009e5c$var$load("9Yw4z"),
    $e4f395b7fd009e5c$var$load("h0uBE"),
    $e4f395b7fd009e5c$var$load("eBLgB"),
    $e4f395b7fd009e5c$var$load("d0Fxy"),
    $e4f395b7fd009e5c$var$load("1n8w9"),
    $e4f395b7fd009e5c$var$load("6NHX3"),
    $e4f395b7fd009e5c$var$load("77dzh")
]).then(()=>parcelRequire('4dnaM'));

});

parcelRegister("9677e", function(module, exports) {

let $69fa319b49dca515$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $69fa319b49dca515$var$load("fLjHM").then(()=>parcelRequire('2qq54'));

});

parcelRegister("lksJj", function(module, exports) {

let $f871c05e7ad2e071$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f871c05e7ad2e071$var$load("3YGga").then(()=>parcelRequire('7iyzo'));

});

parcelRegister("1bipl", function(module, exports) {

let $0dc518e78099ecb1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0dc518e78099ecb1$var$load("ia9y3"),
    $0dc518e78099ecb1$var$load("j9OUx"),
    $0dc518e78099ecb1$var$load("bV8sS"),
    $0dc518e78099ecb1$var$load("kKXTS"),
    $0dc518e78099ecb1$var$load("l079e"),
    $0dc518e78099ecb1$var$load("ebljE"),
    $0dc518e78099ecb1$var$load("hF4v3"),
    $0dc518e78099ecb1$var$load("afU9w")
]).then(()=>parcelRequire('lRTsu'));

});

parcelRegister("5FKXT", function(module, exports) {

let $4215365dbe7d42c4$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4215365dbe7d42c4$var$load("15ncj"),
    $4215365dbe7d42c4$var$load("gDiIK"),
    $4215365dbe7d42c4$var$load("eLlpV"),
    $4215365dbe7d42c4$var$load("7sItg"),
    $4215365dbe7d42c4$var$load("f1B4n"),
    $4215365dbe7d42c4$var$load("j4dSZ"),
    $4215365dbe7d42c4$var$load("1Tuyb"),
    $4215365dbe7d42c4$var$load("7iCpI")
]).then(()=>parcelRequire('jKBtA'));

});

parcelRegister("l2474", function(module, exports) {

var $42omo = parcelRequire("42omo");


const $d23df821b2d2d994$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).lazy(()=>(parcelRequire("gURmQ")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $d23df821b2d2d994$export$2e2bcd8739ae039 = $d23df821b2d2d994$var$AsyncNoAccessTooltip;
module.exports["default"] = $d23df821b2d2d994$export$2e2bcd8739ae039;

});

parcelRegister("gURmQ", function(module, exports) {

let $c50b45f90fc6d653$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $c50b45f90fc6d653$var$load("2lsX7").then(()=>parcelRequire('5zTqW'));

});


//# sourceMappingURL=mention.27d1df01.js.map
